import { render, staticRenderFns } from "./PreviewNotaFiscalServicoView.vue?vue&type=template&id=1f4b7eb0&scoped=true"
import script from "./PreviewNotaFiscalServicoView.vue?vue&type=script&lang=js"
export * from "./PreviewNotaFiscalServicoView.vue?vue&type=script&lang=js"
import style0 from "./PreviewNotaFiscalServicoView.vue?vue&type=style&index=0&id=1f4b7eb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4b7eb0",
  null
  
)

export default component.exports